// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chips__LinearGraphsWidget-module--whQng {
    display: flex;
    gap: calc(var(--px) * 6);
}

.chipTeal__LinearGraphsWidget-module--wG1dw,
.chipOrange__LinearGraphsWidget-module--JpRk4 {
    display: flex;
    align-items: center;
    gap: calc(var(--px) * 6);
    padding: calc(var(--px) * 4) calc(var(--px) * 10);
    border-radius: 999px;
    font-size: calc(var(--px) * 12);
    font-weight: 700;
    white-space: nowrap;
}

.chipTeal__LinearGraphsWidget-module--wG1dw {
    background: var(--color-primary-100);
    color: var(--color-primary-700);
}

.chipOrange__LinearGraphsWidget-module--JpRk4 {
    background: #FDE8D6;
    color: #7A3A06;
}

.chipDotTeal__LinearGraphsWidget-module--lSzSE,
.chipDotOrange__LinearGraphsWidget-module--NKg_q {
    width: calc(var(--px) * 8);
    height: calc(var(--px) * 8);
    border-radius: 50%;
}

.chipDotTeal__LinearGraphsWidget-module--lSzSE {
    background: var(--color-primary-600);
}

.chipDotOrange__LinearGraphsWidget-module--NKg_q {
    background: var(--home-color-orange);
}

.svg__LinearGraphsWidget-module--GM3ut {
    display: block;
    width: calc(var(--px) * 232);
    height: calc(var(--px) * 232);
}

.axisLabel__LinearGraphsWidget-module--c3SY3 {
    font-size: calc(var(--px) * 11);
    font-weight: 700;
    font-style: italic;
}

.lineTeal__LinearGraphsWidget-module--fhBFl,
.lineOrange__LinearGraphsWidget-module--u5tLX {
    stroke-dashoffset: 0;
    opacity: 1;
}

.lineTeal__LinearGraphsWidget-module--fhBFl.animated__LinearGraphsWidget-module--zKuyl {
    animation: draw__LinearGraphsWidget-module--gJ7KB 8s ease-in-out infinite;
}

.lineOrange__LinearGraphsWidget-module--u5tLX.animated__LinearGraphsWidget-module--zKuyl {
    animation: draw__LinearGraphsWidget-module--gJ7KB 8s ease-in-out 0.4s infinite both;
}

@keyframes draw__LinearGraphsWidget-module--gJ7KB {
    0% {
        stroke-dashoffset: 420;
        opacity: 1;
    }
    40%, 90% {
        stroke-dashoffset: 0;
        opacity: 1;
    }
    100% {
        stroke-dashoffset: 0;
        opacity: 0;
    }
}

.intersection__LinearGraphsWidget-module--f9xoF {
    opacity: 1;
    transform-box: fill-box;
    transform-origin: center;
    transform: scale(1);
}

.intersection__LinearGraphsWidget-module--f9xoF.animated__LinearGraphsWidget-module--zKuyl {
    animation: pop__LinearGraphsWidget-module--RDrAW 8s ease-out infinite;
}

@keyframes pop__LinearGraphsWidget-module--RDrAW {
    0%, 56% {
        opacity: 0;
        transform: scale(0.3);
    }
    61% {
        opacity: 1;
        transform: scale(1.18);
    }
    65%, 90% {
        opacity: 1;
        transform: scale(1);
    }
    96%, 100% {
        opacity: 0;
        transform: scale(0.8);
    }
}

.footer__LinearGraphsWidget-module--ubuFm {
    display: flex;
    align-items: center;
    gap: calc(var(--px) * 8);
    font-size: calc(var(--px) * 14);
    font-weight: 700;
    color: var(--color-text-primary);
}

.answerBox__LinearGraphsWidget-module--kkcLb {
    width: calc(var(--px) * 40);
    height: calc(var(--px) * 34);
    border-radius: calc(var(--px) * 9);
    border: calc(var(--px) * 1.5) solid var(--color-neutral-400);
    background: var(--color-neutral-50);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: calc(var(--px) * 18);
    font-weight: 800;
}

.answerDigit__LinearGraphsWidget-module--NiMxG {
    opacity: 1;
}

.tick__LinearGraphsWidget-module--CTnld {
    opacity: 1;
}

.rise__LinearGraphsWidget-module--Hsr52 {
    animation: rise__LinearGraphsWidget-module--Hsr52 8s ease-out infinite;
}

@keyframes rise__LinearGraphsWidget-module--Hsr52 {
    0%, 53% {
        opacity: 0;
        transform: translateY(calc(var(--px) * 12));
    }
    58%, 92% {
        opacity: 1;
        transform: none;
    }
    100% {
        opacity: 0;
    }
}
`, "",{"version":3,"sources":["webpack://./src/main/ui/home/components/LinearGraphsWidget.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,wBAAwB;AAC5B;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,wBAAwB;IACxB,iDAAiD;IACjD,oBAAoB;IACpB,+BAA+B;IAC/B,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;IACpC,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;;IAEI,0BAA0B;IAC1B,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,cAAc;IACd,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,+BAA+B;IAC/B,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;;IAEI,oBAAoB;IACpB,UAAU;AACd;;AAEA;IACI,yEAAuC;AAC3C;;AAEA;IACI,mFAAiD;AACrD;;AAEA;IACI;QACI,sBAAsB;QACtB,UAAU;IACd;IACA;QACI,oBAAoB;QACpB,UAAU;IACd;IACA;QACI,oBAAoB;QACpB,UAAU;IACd;AACJ;;AAEA;IACI,UAAU;IACV,uBAAuB;IACvB,wBAAwB;IACxB,mBAAmB;AACvB;;AAEA;IACI,qEAAmC;AACvC;;AAEA;IACI;QACI,UAAU;QACV,qBAAqB;IACzB;IACA;QACI,UAAU;QACV,sBAAsB;IAC1B;IACA;QACI,UAAU;QACV,mBAAmB;IACvB;IACA;QACI,UAAU;QACV,qBAAqB;IACzB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,wBAAwB;IACxB,+BAA+B;IAC/B,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,2BAA2B;IAC3B,4BAA4B;IAC5B,kCAAkC;IAClC,4DAA4D;IAC5D,mCAAmC;IACnC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,sEAAoC;AACxC;;AAEA;IACI;QACI,UAAU;QACV,2CAA2C;IAC/C;IACA;QACI,UAAU;QACV,eAAe;IACnB;IACA;QACI,UAAU;IACd;AACJ","sourcesContent":[".chips {\n    display: flex;\n    gap: calc(var(--px) * 6);\n}\n\n.chipTeal,\n.chipOrange {\n    display: flex;\n    align-items: center;\n    gap: calc(var(--px) * 6);\n    padding: calc(var(--px) * 4) calc(var(--px) * 10);\n    border-radius: 999px;\n    font-size: calc(var(--px) * 12);\n    font-weight: 700;\n    white-space: nowrap;\n}\n\n.chipTeal {\n    background: var(--color-primary-100);\n    color: var(--color-primary-700);\n}\n\n.chipOrange {\n    background: #FDE8D6;\n    color: #7A3A06;\n}\n\n.chipDotTeal,\n.chipDotOrange {\n    width: calc(var(--px) * 8);\n    height: calc(var(--px) * 8);\n    border-radius: 50%;\n}\n\n.chipDotTeal {\n    background: var(--color-primary-600);\n}\n\n.chipDotOrange {\n    background: var(--home-color-orange);\n}\n\n.svg {\n    display: block;\n    width: calc(var(--px) * 232);\n    height: calc(var(--px) * 232);\n}\n\n.axisLabel {\n    font-size: calc(var(--px) * 11);\n    font-weight: 700;\n    font-style: italic;\n}\n\n.lineTeal,\n.lineOrange {\n    stroke-dashoffset: 0;\n    opacity: 1;\n}\n\n.lineTeal.animated {\n    animation: draw 8s ease-in-out infinite;\n}\n\n.lineOrange.animated {\n    animation: draw 8s ease-in-out 0.4s infinite both;\n}\n\n@keyframes draw {\n    0% {\n        stroke-dashoffset: 420;\n        opacity: 1;\n    }\n    40%, 90% {\n        stroke-dashoffset: 0;\n        opacity: 1;\n    }\n    100% {\n        stroke-dashoffset: 0;\n        opacity: 0;\n    }\n}\n\n.intersection {\n    opacity: 1;\n    transform-box: fill-box;\n    transform-origin: center;\n    transform: scale(1);\n}\n\n.intersection.animated {\n    animation: pop 8s ease-out infinite;\n}\n\n@keyframes pop {\n    0%, 56% {\n        opacity: 0;\n        transform: scale(0.3);\n    }\n    61% {\n        opacity: 1;\n        transform: scale(1.18);\n    }\n    65%, 90% {\n        opacity: 1;\n        transform: scale(1);\n    }\n    96%, 100% {\n        opacity: 0;\n        transform: scale(0.8);\n    }\n}\n\n.footer {\n    display: flex;\n    align-items: center;\n    gap: calc(var(--px) * 8);\n    font-size: calc(var(--px) * 14);\n    font-weight: 700;\n    color: var(--color-text-primary);\n}\n\n.answerBox {\n    width: calc(var(--px) * 40);\n    height: calc(var(--px) * 34);\n    border-radius: calc(var(--px) * 9);\n    border: calc(var(--px) * 1.5) solid var(--color-neutral-400);\n    background: var(--color-neutral-50);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: calc(var(--px) * 18);\n    font-weight: 800;\n}\n\n.answerDigit {\n    opacity: 1;\n}\n\n.tick {\n    opacity: 1;\n}\n\n.rise {\n    animation: rise 8s ease-out infinite;\n}\n\n@keyframes rise {\n    0%, 53% {\n        opacity: 0;\n        transform: translateY(calc(var(--px) * 12));\n    }\n    58%, 92% {\n        opacity: 1;\n        transform: none;\n    }\n    100% {\n        opacity: 0;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chips": `chips__LinearGraphsWidget-module--whQng`,
	"chipTeal": `chipTeal__LinearGraphsWidget-module--wG1dw`,
	"chipOrange": `chipOrange__LinearGraphsWidget-module--JpRk4`,
	"chipDotTeal": `chipDotTeal__LinearGraphsWidget-module--lSzSE`,
	"chipDotOrange": `chipDotOrange__LinearGraphsWidget-module--NKg_q`,
	"svg": `svg__LinearGraphsWidget-module--GM3ut`,
	"axisLabel": `axisLabel__LinearGraphsWidget-module--c3SY3`,
	"lineTeal": `lineTeal__LinearGraphsWidget-module--fhBFl`,
	"lineOrange": `lineOrange__LinearGraphsWidget-module--u5tLX`,
	"animated": `animated__LinearGraphsWidget-module--zKuyl`,
	"draw": `draw__LinearGraphsWidget-module--gJ7KB`,
	"intersection": `intersection__LinearGraphsWidget-module--f9xoF`,
	"pop": `pop__LinearGraphsWidget-module--RDrAW`,
	"footer": `footer__LinearGraphsWidget-module--ubuFm`,
	"answerBox": `answerBox__LinearGraphsWidget-module--kkcLb`,
	"answerDigit": `answerDigit__LinearGraphsWidget-module--NiMxG`,
	"tick": `tick__LinearGraphsWidget-module--CTnld`,
	"rise": `rise__LinearGraphsWidget-module--Hsr52`
};
export default ___CSS_LOADER_EXPORT___;
